<template>
  <div class="card h-100 protip-card text-lg-start">
    <a :href="proTip.url" :aria-label="proTip.name">
      <div class="image-wrap">
        <img :src="proTip.imageUrl" :alt="proTip.name" class="card-img-top"/>
      </div>
    </a>
    <div class="card-body d-flex flex-column">
      <div class="card-title protip-title h4">
        <a :href="proTip.url" class="text-black" v-html="proTip.name"></a>
      </div>
      <div v-if="proTip.memberNames != ''" class="card-title protip-title h5">
        {{ proTip.memberNames }}
      </div>
    </div>
    <div class="card-footer bg-transparent d-none d-lg-block">
      <slot name="protip-result-button" :proTip="proTip"></slot>
    </div>
  </div>
  
</template>

<script>
export default {
    props: ['proTip'],
  computed: {
  },
  methods: {
  },
  mounted() {
  }
}
</script>
